export const DEFAULT_HEADER_OFFSET = 142;
export const DEFAULT_HEADER_ELEMENTS = ['mvd_navbar', 'header--page'];
const bufferHeight = 3;

const sum = (items: number[]) => items.reduce((prev, curr) => prev + curr);

const getElementHeight = (elementClass: string) => {
    const element = <HTMLElement> document.getElementsByClassName(elementClass)[0];
    return element && element.getBoundingClientRect().height;
};

const getOffsetHeight = (offsetElements: string[]) => {
    const offsetElementHeights = offsetElements.map(name => getElementHeight(name));
    const allElementsHaveHeights = offsetElementHeights.every(height => height > 0);
    return allElementsHaveHeights ? sum(offsetElementHeights) + bufferHeight : DEFAULT_HEADER_OFFSET;
};

const getOffset = (element: HTMLElement, offsetElements: string[]) => {
    try {
        const elementPosition = element.getBoundingClientRect().top;
        return elementPosition - getOffsetHeight(offsetElements) + window.scrollY;
    } catch (err) {
        return 0;
    }
};

export const scrollElementBelowHeader = (element: HTMLElement, offsetElements: string[] = DEFAULT_HEADER_ELEMENTS) => {
    window.scrollTo({
        top: getOffset(element, offsetElements),
        behavior: 'smooth'
    });
};

export const scrollTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};
